import { ChangeDetectionStrategy, Component } from '@angular/core';

import { SetGameScoreboardBaseComponent } from '../scoreboard-base/set-game-scoreboard-base.component';

@Component({
    selector: 'ms-set-game-scoreboard-header',
    templateUrl: './set-game-scoreboard-header.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SetGameScoreboardHeaderComponent extends SetGameScoreboardBaseComponent {}
